import { Modal } from '@components/modals';
import React from 'react';

interface UpdateConfigConfirmModalProps {
    showModal: boolean;
    toggleClose: () => void;
    onUpdateWithConfig: () => void;
    onUpdateOnly: () => void;
}

export const UpdateConfigConfirmModal: React.FC<UpdateConfigConfirmModalProps> = ({ 
    showModal, 
    toggleClose,
    onUpdateWithConfig,
    onUpdateOnly
}) => {
    return (
        <Modal
            isOpen={showModal}
            toggleClose={toggleClose}
            title="Update Configuration"
            className="updateConfigConfirmModal"
        >
            <div style={{ marginBottom: '20px', fontSize: '14px', color: 'white' }}>
                Do you want to update configuration as well?
            </div>
            <div className="modalBtns__box" style={{gap:5}}>
                <button
                    className="btn-md btn-yellow"
                    onClick={onUpdateWithConfig}
                    type="button"
                >
                    Update configuration as well
                </button>
                <button
                    className="btn-md btn-yellow"
                    type="button"
                    onClick={onUpdateOnly}
                >
                    Update
                </button>
                <button
                    className="btn-md btn-cancel"
                    type="button"
                    onClick={toggleClose}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};
